// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"G_b1","open":"G_b2","hasResults":"G_bW","shortcut":"G_b3","searchInput":"G_b4","searchIcon":"G_b5"};